module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-447-min.38f5aa26.jpg";